/** @file keyAt: the key of a clip at one frame, if any. */
import type { Clip, ClipKey } from '@zilo/pose3d-format/types/clip';

/** The key whose `frame` is `frame`, or `undefined`. */
export function keyAt(clip: Pick<Clip, 'keys'>, frame: number): ClipKey | undefined {
  return clip.keys.find((k) => k.frame === frame);
}
